const { BASE_URL } = require("./client");

const SUBMIT_FORM = BASE_URL +'/api/question/post'

module.exports = {
    SUBMIT_FORM
}